import React, { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import { getPageInfo } from '../../EMR_Integration/react_webInjector.ts';

const VideoModal = ({ isOpen, onClose, isCX }) => {
  const [emrUrl, setEmrUrl] = useState('');
  const [videoUrl, setVideoUrl] = useState('');

  useEffect(() => {
    if (isCX) {
      const fetchData = async () => {
        try {
          const pageInfo = await getPageInfo();
          console.log('Page Info', pageInfo);

          const url = pageInfo['URL'];
          setEmrUrl(url);
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      };
      fetchData();
    } else {
      setVideoUrl(
        'https://www.loom.com/embed/ac87499215bf4b8c9fdf006ce7b19e82?sid=3d5cba06-4b09-4422-959a-a47083bcc582',
      );
    }
  }, [isCX]);

  useEffect(() => {
    if (isCX) {
      // Define URLs for different platforms
      const urls = {
        'secure.mwtherapy.com':
          'https://www.loom.com/embed/da49f419778b48e78fe02e0939a6a196?sid=873b42f2-5291-4a0f-8301-97f55dbe9755',
        'app.empoweremr.com':
          'https://www.loom.com/embed/da49f419778b48e78fe02e0939a6a196?sid=873b42f2-5291-4a0f-8301-97f55dbe9755',
        'go.promptemr.com':
          'https://docs.google.com/document/d/1NMne2bcCUNOLJS9rhS_v3xmd7RE1wY6BRu3ZkQG9VSM/edit?usp=sharing',
        'comprehendpi.janeapp.com':
          'https://www.youtube.com/embed/LBdnRblaMME?si=AI4WBJnbtgOnQ3SK',
        'janeapp.com':
          'https://www.youtube.com/embed/LBdnRblaMME?si=AI4WBJnbtgOnQ3SK',
        'app.webpt.com':
          'https://docs.google.com/document/d/1Ja_SS2MYznuwwJGgjeh-g-fziuFllmwiEYlShhzoQjM/edit?usp=sharing',
        'emr.webpt.com':
          'https://docs.google.com/document/d/1Ja_SS2MYznuwwJGgjeh-g-fziuFllmwiEYlShhzoQjM/edit?usp=sharing',
        'app.pteverywhere.com':
          'https://www.loom.com/share/5a12c469cae149c2a91bcbbbc4f22b6f?sid=6eb96c4e-2f9f-4a7f-9b8a-d297e5954398',
      };

      let defaultVideoUrl = 'https://www.youtube.com/watch?v=LBdnRblaMME&t=1s'; // Default URL
      for (const key in urls) {
        if (emrUrl.includes(key)) {
          defaultVideoUrl = urls[key];
          break; // Stop once a match is found
        }
      }

      setVideoUrl(defaultVideoUrl);
    }
  }, [emrUrl, isCX]);

  if (!isOpen) return null; // Early exit if the modal is not open

  // Check the type of URL and set up the iframe accordingly
  const isGoogleDoc = videoUrl.includes('docs.google.com');
  const isYouTube = videoUrl.includes('youtube.com');

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            Template Builder Guide
          </h5>
        </div>
        <div className="modal-body">
          <div
            style={{
              position: 'relative',
              paddingBottom: '53.125%',
              height: 0,
            }}
          >
            {isGoogleDoc ? (
              window.open(
                videoUrl.replace('/edit?usp=sharing', '/preview'),
                '_blank',
              )
            ) : isYouTube ? (
              <iframe
                width="560"
                height="315"
                src={videoUrl.replace('watch?v=', 'embed/')}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                }}
              ></iframe>
            ) : (
              <iframe
                src={videoUrl}
                frameBorder="0"
                webkitAllowFullScreen
                mozAllowFullScreen
                allowFullScreen
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                }}
                title="Template Builder Guide"
              ></iframe>
            )}
          </div>
        </div>
        <div
          className="modal-footer"
          style={{
            display: 'flex',
            justifyContent: 'center', // Center horizontally
            padding: '1rem', // Optional: Adjust padding as needed
          }}
        >
          <Button color="primary" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

export default VideoModal;
